module.exports = __webpack_public_path__ + "static/media/under16-mission1-graphic.df602a45.png";